/* ============================================================
   dealer-partnerships.js — 经销商申请表单
   对应 sections/dealer-partnerships.liquid。
   基于旧站实现重写：全部 data-* 选择器 + section 作用域；
   错误文案不写死，从 [data-dealer-form] 的 data-error-* 读取（locales 提供）。
   功能：展开/收起、前端校验、sessionStorage 草稿、放弃确认弹窗、
   提交前把全部字段汇总进 contact[body]、按 contact_posted 显示成功视图。
   ============================================================ */
(function () {
  'use strict';

  // Shopify contact 表单要求字段名是 contact[xxx]；内部逻辑 key 与
  // [data-dealer-error="xxx"] 对应，经 FIELD_NAMES 映射到真实 name。
  var FIELD_NAMES = {
    firstName: 'contact[name]',
    email: 'contact[email]',
    company: 'contact[company]',
    country: 'contact[country]',
    website: 'contact[website]',
    phone: 'contact[phone]',
    partnershipType: 'contact[partnership_type]',
    markets: 'contact[markets]',
    salesChannels: 'contact[sales_channels][]',
    retailLocations: 'contact[retail_locations]',
    fit: 'contact[body]',
    privacy: 'contact[privacy_agreed]'
  };

  function initSection(section) {
    var applyButton = section.querySelector('[data-dealer-apply]');
    var defaultPanel = section.querySelector('[data-dealer-default-panel]');
    var formWrap = section.querySelector('[data-dealer-form]');
    var form = formWrap && formWrap.querySelector('form');
    var success = section.querySelector('[data-dealer-success]');
    var formTitle = section.querySelector('#dealer-form-title');
    var live = section.querySelector('[data-dealer-live]');
    var submitError = section.querySelector('[data-dealer-submit-error]');
    var confirmDialog = section.querySelector('[data-dealer-confirm]');
    var keepButton = section.querySelector('[data-dealer-keep]');
    var discardButton = section.querySelector('[data-dealer-discard]');
    var returnButton = section.querySelector('[data-dealer-return]');
    var retailField = section.querySelector('[data-dealer-retail-field]');
    var physicalCheckbox = section.querySelector('[data-dealer-physical]');
    var tagsWrap = section.querySelector('[data-dealer-channel-tags]');
    if (!form || !applyButton) return;

    var STORAGE_KEY = 'tempolor_dealer_application';
    var messages = {
      firstName: formWrap.dataset.errorFirstName,
      email: formWrap.dataset.errorEmail,
      company: formWrap.dataset.errorCompany,
      country: formWrap.dataset.errorCountry,
      website: formWrap.dataset.errorWebsite,
      partnershipType: formWrap.dataset.errorPartnership,
      salesChannels: formWrap.dataset.errorChannels,
      privacy: formWrap.dataset.errorPrivacy
    };
    var touched = new Set();
    var confirmPreviousFocus = null;

    var el = function (key) {
      return form.elements[FIELD_NAMES[key] || key];
    };
    var fields = function () {
      return Array.from(form.querySelectorAll('input, select, textarea'));
    };
    var channelChecks = function () {
      return Array.from(form.querySelectorAll('input[name="' + FIELD_NAMES.salesChannels + '"]'));
    };
    var selectedChannels = function () {
      return channelChecks()
        .filter(function (item) {
          return item.checked;
        })
        .map(function (item) {
          return item.value;
        });
    };

    /* ── 草稿持久化 ─────────────────────────────────────── */
    function persistData() {
      var data = {};
      form.querySelectorAll('[data-dealer-persist]').forEach(function (field) {
        if (field.type === 'checkbox') {
          data.salesChannels = selectedChannels();
        } else {
          data[field.name] = field.value;
        }
      });
      try {
        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
      } catch (e) {
        /* storage 不可用时保持表单可用 */
      }
    }

    function restoreData() {
      var data = {};
      try {
        data = JSON.parse(sessionStorage.getItem(STORAGE_KEY) || '{}');
      } catch (e) {
        data = {};
      }
      Object.keys(data).forEach(function (name) {
        var value = data[name];
        if (name === 'salesChannels' && Array.isArray(value)) {
          channelChecks().forEach(function (check) {
            check.checked = value.indexOf(check.value) !== -1;
          });
        } else {
          var field = form.elements[name];
          if (field && typeof value === 'string') field.value = value;
        }
      });
    }

    function clearDraft() {
      try {
        sessionStorage.removeItem(STORAGE_KEY);
      } catch (e) {
        /* ignore */
      }
    }

    /* ── 校验 ───────────────────────────────────────────── */
    function setFieldError(name, message) {
      var field = el(name);
      var error = section.querySelector('[data-dealer-error="' + name + '"]');
      var group =
        name === 'salesChannels'
          ? section.querySelector('.dealer-channels')
          : field && field.closest && field.closest('.dealer-field, .dealer-channels, .dealer-privacy');
      if (!field || !group || !error) return;
      group.classList.toggle('is-invalid', Boolean(message));
      if (name === 'salesChannels') {
        channelChecks().forEach(function (check) {
          check.setAttribute('aria-invalid', message ? 'true' : 'false');
        });
      } else if (field.setAttribute) {
        field.setAttribute('aria-invalid', message ? 'true' : 'false');
      }
      error.textContent = message || '';
    }

    function validateContact() {
      var ok = true;
      var email = el('email').value.trim();
      var website = el('website').value.trim();
      var urlOk = false;
      try {
        var url = new URL(website);
        urlOk = Boolean(url.protocol.match(/^https?:$/) && url.hostname);
      } catch (e) {
        urlOk = false;
      }
      [
        ['firstName', el('firstName').value.trim() ? '' : messages.firstName],
        ['email', /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) ? '' : messages.email],
        ['company', el('company').value.trim() ? '' : messages.company],
        ['country', el('country').value ? '' : messages.country],
        ['website', urlOk ? '' : messages.website]
      ].forEach(function (pair) {
        setFieldError(pair[0], pair[1]);
        if (pair[1]) ok = false;
      });
      return ok;
    }

    function validatePartnership() {
      var partnershipError = el('partnershipType').value ? '' : messages.partnershipType;
      var channelError = selectedChannels().length ? '' : messages.salesChannels;
      var privacyError = el('privacy').checked ? '' : messages.privacy;
      setFieldError('partnershipType', partnershipError);
      setFieldError('salesChannels', channelError);
      setFieldError('privacy', privacyError);
      return !partnershipError && !channelError && !privacyError;
    }

    function isDirty() {
      return fields().some(function (field) {
        if (field.type === 'checkbox') return field.checked;
        return field.value.trim();
      });
    }

    /* ── 渠道 tags 与条件字段 ───────────────────────────── */
    function updateChannels() {
      if (retailField) retailField.hidden = !(physicalCheckbox && physicalCheckbox.checked);
      if (tagsWrap) {
        tagsWrap.innerHTML = '';
        selectedChannels().forEach(function (channel) {
          var tag = document.createElement('button');
          tag.type = 'button';
          tag.textContent = channel;
          tag.setAttribute('aria-label', 'Remove ' + channel);
          tag.addEventListener('click', function () {
            var match = channelChecks().find(function (check) {
              return check.value === channel;
            });
            if (match) match.checked = false;
            updateChannels();
            persistData();
          });
          tagsWrap.append(tag);
        });
      }
      persistData();
    }

    /* ── 面板切换 ───────────────────────────────────────── */
    function openForm() {
      section.classList.add('is-application-open');
      applyButton.setAttribute('aria-expanded', 'true');
      success.hidden = true;
      defaultPanel.hidden = true;
      formWrap.hidden = false;
      if (submitError && !form.dataset.serverError) submitError.hidden = true;
      if (live) live.textContent = formWrap.dataset.openedMessage || '';
      if (formTitle) formTitle.focus({ preventScroll: true });
    }

    function collapseForm() {
      section.classList.remove('is-application-open');
      formWrap.hidden = true;
      success.hidden = true;
      defaultPanel.hidden = false;
      applyButton.setAttribute('aria-expanded', 'false');
      applyButton.focus({ preventScroll: true });
    }

    function showSuccess() {
      section.classList.add('is-application-open');
      defaultPanel.hidden = true;
      formWrap.hidden = true;
      success.hidden = false;
      var title = success.querySelector('h3');
      if (title) title.focus({ preventScroll: true });
    }

    /* ── 放弃确认弹窗 ───────────────────────────────────── */
    function openConfirm() {
      confirmPreviousFocus = document.activeElement;
      confirmDialog.hidden = false;
      keepButton.focus();
    }

    function closeConfirm() {
      confirmDialog.hidden = true;
      if (confirmPreviousFocus && confirmPreviousFocus.focus) {
        confirmPreviousFocus.focus({ preventScroll: true });
      }
    }

    function resetForm() {
      form.reset();
      touched = new Set();
      Object.keys(FIELD_NAMES).forEach(function (key) {
        setFieldError(key, '');
      });
      updateChannels();
      clearDraft();
    }

    /* ── 事件绑定 ───────────────────────────────────────── */
    applyButton.addEventListener('click', openForm);
    if (returnButton) returnButton.addEventListener('click', collapseForm);

    function handleFormMutation(event) {
      var field = event.target;
      if (field && field.name) touched.add(field.name);
      if (field && field.matches && field.matches('[data-dealer-persist]')) persistData();
      if (field && field.name === FIELD_NAMES.salesChannels) updateChannels();
    }
    form.addEventListener('input', handleFormMutation);
    form.addEventListener('change', handleFormMutation);

    form.addEventListener(
      'blur',
      function (event) {
        var name = event.target && event.target.name;
        if (!name || !touched.has(name)) return;
        validateContact();
        validatePartnership();
      },
      true
    );

    form.querySelectorAll('[data-dealer-cancel]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (isDirty()) openConfirm();
        else collapseForm();
      });
    });

    if (keepButton) keepButton.addEventListener('click', closeConfirm);
    if (discardButton) {
      discardButton.addEventListener('click', function () {
        closeConfirm();
        resetForm();
        collapseForm();
      });
    }

    if (confirmDialog) {
      confirmDialog.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          closeConfirm();
          return;
        }
        if (event.key !== 'Tab') return;
        var controls = Array.from(confirmDialog.querySelectorAll('button'));
        var first = controls[0];
        var last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });
    }

    // Shopify 默认的 Contact 通知邮件只展示 name/email/phone/body，
    // 其它 contact[xxx] 自定义字段不会出现在邮件里；这里把全部字段
    // 汇总进 body，保证不改通知模板也能看到完整申请内容。
    function buildSummary() {
      var lines = [
        'Company: ' + el('company').value.trim(),
        'Country / region: ' + el('country').value,
        'Business website: ' + el('website').value.trim(),
        'Phone: ' + ((el('phone') && el('phone').value.trim()) || '-'),
        'Partnership type: ' + el('partnershipType').value,
        'Markets covered: ' + ((el('markets') && el('markets').value.trim()) || '-'),
        'Sales channels: ' + (selectedChannels().join(', ') || '-')
      ];
      if (physicalCheckbox && physicalCheckbox.checked) {
        lines.push('Retail locations: ' + ((el('retailLocations') && el('retailLocations').value.trim()) || '-'));
      }
      var bodyField = el('fit');
      var userNote = bodyField.value.trim();
      var summary = lines.join('\n');
      bodyField.value = userNote ? summary + '\n\nAdditional notes:\n' + userNote : summary;
    }

    form.addEventListener('submit', function (event) {
      Object.keys(FIELD_NAMES).forEach(function (key) {
        touched.add(FIELD_NAMES[key]);
      });
      var validContact = validateContact();
      var validPartnership = validatePartnership();
      if (!validContact || !validPartnership) {
        event.preventDefault();
        return;
      }
      // 前端校验通过，交给 Shopify contact form 正常提交
      buildSummary();
      clearDraft();
    });

    /* ── 初始化 ─────────────────────────────────────────── */
    restoreData();
    updateChannels();

    // 提交回跳：成功（Shopify contact form 回跳带 ?contact_posted=true）→ 成功视图并清草稿；
    // 服务端 form.errors → 展开表单显示错误条
    if (window.location.search.indexOf('contact_posted=true') !== -1) {
      clearDraft();
      showSuccess();
      section.scrollIntoView({ block: 'center' });
    } else if (submitError && !submitError.hidden) {
      form.dataset.serverError = '1';
      openForm();
      section.scrollIntoView({ block: 'center' });
    }
  }

  function init() {
    document.querySelectorAll('[data-dealer-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
